/**
 * Anchors the product tour attaches to. A dedicated `data-tour` attribute rather than reusing
 * `data-testid`: test selectors and the tour's spotlight have different lifetimes, and a
 * renamed test id should never silently move a tooltip in production.
 */
export const TOUR_TARGETS = {
  navDashboard: 'nav-dashboard',
  navDevices: 'nav-devices',
  navPlansWorkflows: 'nav-plans-workflows',
  navAppCustomization: 'nav-app-customization',
  globalSearch: 'global-search',
  profile: 'profile',
} as const;

export type TourTarget = (typeof TOUR_TARGETS)[keyof typeof TOUR_TARGETS];

/** The CSS selector Joyride resolves a step against. */
export function tourSelector(target: TourTarget): string {
  return `[data-tour="${target}"]`;
}
